import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

import { dateRangeZodObject } from "@@/shared/date-time/date-range";
import { idZodSchema } from "@@/shared/id";
import { contactInfoZodObject } from "@@/shared/locations/contact-info";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { headQuoteItemZodSchema } from "@@/shared/quotes/quote";
import { recipientsZodObject } from "@@/shared/quotes/quote-base";
import { quoteIdZodSchema } from "@@/shared/quotes/quote-id";
import { translatableZodSchema } from "@@/shared/translations/translation";

const quoteEditCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("EDIT_QUOTE_COMMAND"),
    quoteId: quoteIdZodSchema,
    providerId: providerIdZodSchema,

    title: translatableZodSchema,
    reference: z.string(),
    valid: dateRangeZodObject,

    recipients: z.array(recipientsZodObject),

    customer: contactInfoZodObject,

    items: z.array(headQuoteItemZodSchema), //.optional(),
});
type QuoteEditCommand = z.infer<typeof quoteEditCommandZodSchema>;
const QuoteEditCommandFactoryParamsZodObject = quoteEditCommandZodSchema.omit({
    _id: true,
    _type: true,
});

type QuoteEditCommandFactoryParams = z.infer<
    typeof QuoteEditCommandFactoryParamsZodObject
>;
const quoteEditCommandFactory = (
    params: QuoteEditCommandFactoryParams,
): QuoteEditCommand => {
    return {
        ...params,
        _id: generateId("EDIT_quote_command__"), // Or however you generate IDs
        _type: "EDIT_QUOTE_COMMAND",
    };
};

export {
    quoteEditCommandFactory,
    QuoteEditCommandFactoryParamsZodObject,
    quoteEditCommandZodSchema,
};
export type { QuoteEditCommand, QuoteEditCommandFactoryParams };
